var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { "fill-height": "", "pa-0": "" } },
    [
      _c(
        "v-flex",
        { attrs: { xs4: "", "text-xs-left": "" } },
        [
          _c("v-subheader", [
            _c(
              "strong",
              {
                staticClass: "text-lg-right",
                class: _vm.isRequired
                  ? "label-required--has-required"
                  : "label-required--norequired"
              },
              [_vm._v(_vm._s(_vm.$t(_vm.label)))]
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("v-flex", { attrs: { xs7: "" } }, [_vm._t("default")], 2)
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1a6d85a4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a6d85a4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/containers/ticket/components/ticket-modal-group-control/template.html
// module id = null
// module chunks = 